import { DirectMembership } from 'lib/accountList'

/* Stands in when neither source names the account, so a legend entry never renders as a colour
 * swatch with nothing beside it. */
export const FALLBACK_ACCOUNT_NAME = 'Your Company'

/* The name to show for the account someone is signed in to. Tenant settings are the record, but
 * they arrive a request after sign-in and stay empty for the whole session if that request fails,
 * so the membership list the identity provider keeps in the browser stands in for them. */
export const resolveAccountName = (
  settingsName?: string | null,
  memberships?: DirectMembership[] | null,
  activeTenantId?: string | null
): string => {
  const fromSettings = settingsName?.trim()
  if (fromSettings) return fromSettings

  const fromMembership = memberships?.find((membership) => membership.tenantId === activeTenantId)?.name?.trim()

  return fromMembership || FALLBACK_ACCOUNT_NAME
}
